<template>
  <div class="letters">
    <LetterNumbersStep :step="1" label="Select Style" initially-open>
      <Styles />
    </LetterNumbersStep>

    <LetterNumbersStep :step="2" label="Select Font">
      <LettersFont :fonts="fontOptions" />
    </LetterNumbersStep>

    <LetterNumbersStep :step="3" label="Select Size">
      <Sizes />
    </LetterNumbersStep>

    <LetterNumbersStep :step="4" label="Select Color">
      <Color />
    </LetterNumbersStep>

    <LetterNumbersStep :step="5" label="Add Name/Word">
      <AddLetters />
    </LetterNumbersStep>
  </div>
</template>

<script setup>
import LetterNumbersStep from "components/jiffy/vue-product-details-dtf/LetterNumbersStep.vue";
import LettersFont from "components/jiffy/vue-product-details-dtf/Letters/LettersFont.vue";
import Styles from "components/jiffy/vue-product-details-dtf/Letters/Styles.vue";
import Sizes from "components/jiffy/vue-product-details-dtf/Letters/Sizes.vue";
import Color from "components/jiffy/vue-product-details-dtf/Letters/Color.vue";
import AddLetters from "components/jiffy/vue-product-details-dtf/Letters/AddLetters.vue";

const fontOptions = [
  { label: "Promesh", value: "promesh" },
  { label: "Emilio", value: "emilio" },
  { label: "Niconne", value: "niconne" },
  { label: "Squares", value: "squares-bold" },
  { label: "Beantown", value: "beantown" },
  { label: "Octin Sports", value: "octin-sports" },
  { label: "Soccer League", value: "soccer-league" },
  { label: "Rueckwarzsalto", value: "rueckwarzsalto" },
  { label: "Facon", value: "facon" },
  { label: "Varsity Team", value: "varsity-team" }
];
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.letters {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

@font-face {
  font-family: "Facon";
  src: url("https://jiffy.imgix.net/2/fonts/facon.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Niconne";
  src: url("https://jiffy.imgix.net/2/fonts/niconne.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Beantown";
  src: url("https://jiffy.imgix.net/2/fonts/beantown.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Octin Sports";
  src: url("https://jiffy.imgix.net/2/fonts/octin_sports.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Promesh";
  src: url("https://jiffy.imgix.net/2/fonts/promesh.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Rueckwarzsalto";
  src: url("https://jiffy.imgix.net/2/fonts/rueckwarzsalto.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Soccer League";
  src: url("https://jiffy.imgix.net/2/fonts/soccer_league.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Squares Bold";
  src: url("https://jiffy.imgix.net/2/fonts/squares_bold.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Varsity Team";
  src: url("https://jiffy.imgix.net/2/fonts/varsity_team.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
</style>
